<!--
 * @Description:
 * @Author: wjx
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-04-10 09:48:28
 * @LastEditTime: 2020-05-21 23:01:27
 -->
<template>
  <div class="block">
    <div class="logo" @click="goHome">
      <img src="http://cdn.yxvzb.com/WEB/sass/img/logo1.png" style="width:2.4em;height:2.4em;">
      <h1 style="font-size:1.625em;padding-left:15px;font-weight:normal">向日葵发起方管理平台</h1>
    </div>
    <!-- <el-menu background-color="#fff" text-color="#fff" active-text-color="#027CFA" :default-active="tabActive" class="el-menu-demo" mode="horizontal" @select="handleSelect">
    <el-menu-item v-for="item in tabList" :index="item">{{item}}</el-menu-item>


    </el-menu>-->
    <!-- <ul class="header-tab-ul">
    <li v-for="(item,index) in tabList" :class="['header-tab-li',tabActive == item?'header-tab-li-active':'']" :key="item" @click="handleSelect(item,index)">
      {{item}}
    </li>
    </ul>-->
    <div class="right">
      <ct-user class="hand"></ct-user>
      <!-- <el-badge :value="12" class="item " style="margin-left:20px">
      <i class="el-icon-bell" style="font-size:25px"></i>
      </el-badge>-->
    </div>
  </div>
</template>
<script>
import {
  mapState,
  mapMutations
} from 'vuex'
import ctUser from '@/components/Common/user.vue'
export default {
  data () {
    return {
      activeIndex: '1',
      activeIndex2: '1'
    };
  },
  methods: {
    ...mapMutations({
      TABACTIVE: 'TABACTIVE',
      CHANGEASIDEACTIVE: 'CHANGEASIDEACTIVE',

    }),
    goHome () {
      this.$router.push({
        name: 'home'
      })
    },
    handleSelect (key, index) {
      //切换时重置aside当前激活
      let menuRoute = this.menusList[key].menus[0].menu_name
      this.TABACTIVE(key)// 改变headerTab 状态


      this.CHANGEASIDEACTIVE(menuRoute) // 改变aside列表
      this.$router.push({ // 对应路由 转跳对应menu第一个地址
        path: this.menusList[key].menus[0].menu_url
      })
    }
  },
  computed: {
    ...mapState({
      menusList: state => state.aside.menusList,
      tabList: state => Object.keys(state.aside.menusList),
      tabActive: state => state.aside.tabActive,
      defaultAsideActive: state => state.aside.defaultAsideActive,

    })
  },
  components: {
    ctUser
  },
  created () {
    // 初始化
    this.TABACTIVE(this.$route.matched[0].meta.headerNavName)

  }
}
</script>
<style lang="scss" scoped>
.block {
  display: flex;
  align-items: center;
  background: #027cfa;
  position: relative;
  height: 60px !important;
  padding-left: 28px;
  // min-height: 56px;
  // max-height: 90px;
  .right {
    position: absolute;
    right: 50px;
    display: flex;
    align-items: center;
    color: #fff;
  }
  .logo {
    // padding: 0 5px;
    display: flex;
    align-items: center;
    img {
      width: 130px;
    }
  }
  .logo:hover {
    cursor: pointer;
  }
  .header-tab-ul {
    display: flex;
    padding-left: 50px;
    .header-tab-li {
      padding: 5px 15px;
      border-radius: 4px;
      font-size: 16px;
      color: #fff;
      background: transtarent;
      text-align: center;
      margin-right: 5px;
      cursor: pointer;
    }
    .header-tab-li-active {
      color: #027cfa;
      background: #ffffff;
    }
  }
}
</style>
